import { render, staticRenderFns } from "./ReviewForm.vue?vue&type=template&id=000d9944&scoped=true&"
import script from "./ReviewForm.vue?vue&type=script&lang=js&"
export * from "./ReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./ReviewForm.vue?vue&type=style&index=0&id=000d9944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d9944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
